import { classNames, h, OmiProps } from "omi";

import { IconName, NWIcon } from "@/components/atoms/nw-icon";

type Props = {
  icon?: IconName;
  selected: boolean;
  onClick?: () => void;
};

export function FilterCheckbox({ selected, icon, children, onClick }: OmiProps<Props>) {
  return (
    <button
      class={classNames(
        "border hover:bg-gray-50 transition-colors duration-[50ms] rounded-lg bg-white py-1 px-2 space-x-1 inline-flex items-center text-secondary",
        { "border-brand-300": selected },
        { "border-gray-200": !selected },
      )}
      onClick={onClick}
    >
      {icon && <NWIcon name={icon} width={16} height={16} />}
      <div class="text-sm">{children}</div>
    </button>
  );
}
